import React from 'react';

import { Box, Typography } from '@mui/material';

import { useResourcesInboxItem } from 'src/hooks/resources/useResourcesInboxItem';

import { ResourcesInboxItemCard } from './InboxItemCard';

export const InboxItemsListOnlyWithResources: React.FC = () => {
  const { resourcesInboxItem } = useResourcesInboxItem();

  return (
    <Box height="100%" display="flex" flexDirection="column">
      <ResourcesInboxItemCard inboxItemId={resourcesInboxItem.id || ''} />

      <Box padding={4}>
        <Typography variant="body2" color="text.secondary" textAlign="center">
          Verification Request Feed is unavailable at the manager permission level
        </Typography>
      </Box>
    </Box>
  );
};
